import { type CSSProperties } from 'react';
import { Drawer } from '@helios/ui/overlay';
import { Button } from '@helios/ui/button';
import { NavIcon } from './shared';
import type { PatientVitalEntryWithDefinitionRow } from '@helios/data-access';
import { VitalsDetailView } from './VitalsDetailView';

// ─── Types ───

type LatestVitalsGrouped = {
  primary: PatientVitalEntryWithDefinitionRow[];
  additional: PatientVitalEntryWithDefinitionRow[];
  recordedAt: string;
};

interface AllVitalsDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  brandTokens: Record<string, string>;
  latestVitals: LatestVitalsGrouped | null;
  /** Full vitals history (unlimited). Pass qAllPatientVitalsHistory results. */
  historyRows: PatientVitalEntryWithDefinitionRow[];
  /** Opens the Record Vitals drawer. */
  onRecord: () => void;
}

/**
 * Right-side drawer showing the patient's complete vitals history (PRD-less
 * follow-up). Reuses VitalsDetailView for the body with its own header hidden
 * (the drawer supplies the title) and the full — not last-10 — history.
 */
export function AllVitalsDrawer({
  open,
  onOpenChange,
  brandTokens,
  latestVitals,
  historyRows,
  onRecord,
}: AllVitalsDrawerProps) {
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      title="All Vitals"
      portalStyle={brandTokens as CSSProperties}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="outline" size="md" leftIcon={<NavIcon name="plus" />} onClick={onRecord}>
            Record Vitals
          </Button>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-4)' }}>
        <VitalsDetailView
          hideHeader
          latestVitals={latestVitals}
          historyRows={historyRows}
          historyLabel="History"
        />
      </div>
    </Drawer>
  );
}
